import { Card, CardProps, Flex, FlexProps } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import InstagramIcon from "common/icons/instagram"
import TelegramIcon from "common/icons/telegram"
import Link from "next/link"




const SocialLinks = () => {
    const mobileMatches = useMediaQuery('(max-width: 768px)')


    const cardProps: CardProps = {
        radius: 16,
        bd: "1px solid #7C877863",
        p: 4,
        bg: "transparent",
        w: { base: 32, sm: 48 },
        h: { base: 32, sm: 48 }
    }

    const flexProps: FlexProps = {
        align: "center",
        justify: "center",
        w: "100%",
        h: "100%"
    }



    return (
        <Flex
            align="center"
            gap="md"
        >
            <Link href="https://t.me/mdostisalam">
                <Card {...cardProps}>
                    <Flex {...flexProps}>
                        <TelegramIcon size={mobileMatches ? 16 : 24} />
                    </Flex>
                </Card>
            </Link>

            <Link href="https://www.instagram.com/salamsakhteman">
                <Card {...cardProps}>
                    <Flex {...flexProps}>
                        <InstagramIcon size={mobileMatches ? 16 : 24} />
                    </Flex>
                </Card>
            </Link>

            <Link href="https://api.whatsapp.com/send?phone=989113076892&text=%D8%B3%D9%84%D8%A7%D9%85%D9%85%DB%8C%D8%AE%D9%88%D8%A7%D9%87%D9%85%20%D8%A8%D8%A7%20%DA%A9%D8%A7%D8%B1%D8%B4%D9%86%D8%A7%D8%B3%20%D8%B3%D9%84%D8%A7%D9%85%20%D8%B3%D8%A7%D8%AE%D8%AA%D9%85%D8%A7%D9%86%20%D8%AF%D8%B1%20%D8%A7%D8%B1%D8%AA%D8%A8%D8%A7%D8%B7%20%D8%A8%D8%A7%D8%B4%D9%85">
                <Card {...cardProps}>
                    <Flex {...flexProps}>
                        <svg
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            width={mobileMatches ? 16 : 24}
                            height={mobileMatches ? 16 : 24}
                        >
                            <g strokeWidth="url(#clip0)">
                                <path
                                    d="M23.3811 5.68945C20.8092 3.22852 17.3839 1.875 13.7439 1.875C6.23047 1.875 0.116629 7.71094 0.116629 14.8828C0.116629 17.1738 0.742746 19.4121 1.93359 21.3867L0 28.125L7.22489 26.3145C9.21373 27.3516 11.4542 27.8965 13.7377 27.8965H13.7439C21.2511 27.8965 27.5 22.0605 27.5 14.8887C27.5 11.4141 25.9531 8.15039 23.3811 5.68945ZM13.7439 25.7051C11.7059 25.7051 9.71094 25.1836 7.97377 24.1992L7.5625 23.9648L3.2779 25.0371L4.41964 21.0469L4.14955 20.6367C3.01395 18.9141 2.41853 16.9277 2.41853 14.8828C2.41853 8.92383 7.50112 4.07227 13.75 4.07227C16.7762 4.07227 19.6183 5.19727 21.7545 7.24219C23.8906 9.28711 25.2042 12 25.1981 14.8887C25.1981 20.8535 19.9866 25.7051 13.7439 25.7051ZM19.9559 17.6074C19.6183 17.4434 17.9425 16.6582 17.6295 16.5527C17.3164 16.4414 17.0893 16.3887 16.8622 16.7168C16.635 17.0449 15.9844 17.7715 15.7818 17.9941C15.5854 18.2109 15.3828 18.2402 15.0452 18.0762C13.0441 17.1211 11.7305 16.3711 10.4107 14.209C10.0608 13.6348 10.7606 13.6758 11.4113 12.4336C11.5218 12.2168 11.4665 12.0293 11.3806 11.8652C11.2946 11.7012 10.6133 10.1016 10.3309 9.45117C10.0547 8.81836 9.77232 8.90625 9.56362 8.89453C9.36719 8.88281 9.14007 8.88281 8.91295 8.88281C8.68583 8.88281 8.31752 8.96484 8.00446 9.28711C7.69141 9.61523 6.81362 10.4004 6.81362 12C6.81362 13.5996 8.03516 15.1465 8.20089 15.3633C8.37277 15.5801 10.601 18.8613 14.0201 20.2734C16.1808 21.1641 17.0279 21.2402 18.1083 21.0879C18.7651 20.9941 20.1217 20.3027 20.404 19.541C20.6864 18.7793 20.6864 18.1289 20.6004 17.9941C20.5206 17.8477 20.2935 17.7656 19.9559 17.6074Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="28" height="28" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </Flex>
                </Card>
            </Link>
        </Flex>
    )
}

export default SocialLinks